<script setup>
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useStore } from 'vuex';
import { useInternalChatStore } from 'dashboard/stores/internalChat';

import ThreadList from './ThreadList.vue';
import ThreadWindow from './ThreadWindow.vue';

const { t } = useI18n();
const store = useInternalChatStore();
const vuexStore = useStore();
const { totalUnread } = storeToRefs(store);

onMounted(() => {
  store.fetchThreads();
  // Garante presenca/listas de agentes e times para nomear DMs/canais.
  vuexStore.dispatch('agents/get');
  vuexStore.dispatch('teams/get');
});
</script>

<template>
  <div class="flex flex-col w-full h-full bg-n-surface-1">
    <header
      class="flex gap-2 items-center px-4 h-14 border-b shrink-0 border-n-weak"
    >
      <span class="i-lucide-messages-square size-5 text-n-slate-11" />
      <h1 class="text-base font-medium text-n-slate-12">
        {{ t('INTERNAL_CHAT.TITLE') }}
      </h1>
      <span
        v-if="totalUnread"
        class="flex justify-center items-center px-1.5 min-w-5 h-5 text-xs font-medium text-white rounded-full bg-n-brand"
      >
        {{ totalUnread }}
      </span>
    </header>
    <div class="flex flex-1 min-h-0">
      <ThreadList />
      <ThreadWindow />
    </div>
  </div>
</template>
